import { Box, IconButton } from "@mui/material";
import Logo from "../../assets/images/logo.svg?react";
import { useState } from "react";
import MenuContainer from "./MenuContainer";
import DensityMediumIcon from "@mui/icons-material/DensityMedium";

const MenuBar = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Box
      sx={{
        display: { xs: "flex", lg: "none" },
        alignItems: "center",
        px: "24px",
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          margin: "20px 20px",
        }}
      >
        <Logo />
      </Box>

      <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 2 }}
        aria-controls={open ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <DensityMediumIcon />
      </IconButton>
      <MenuContainer
        anchorEl={anchorEl}
        open={open}
        handleClose={handleClose}
      />
    </Box>
  );
};

export default MenuBar;
